<div class="row">
  <div class="col-md-12">
     
      <div [attr.id]="dropZoneId" class="dropzone">
      </div>
  </div>
  </div>